import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import SupabaseWrapper from './SupabaseWrapper'
import BandeauEnvironnement from './components/layout/BandeauEnvironnement'
import './styles/main.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BandeauEnvironnement />
    <SupabaseWrapper>
      <App />
    </SupabaseWrapper>
  </React.StrictMode>
)
